<template>
  <div class="px-3 py-2 info_field" :class="`info_field--${variant}`">
    {{ label }}
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    variant: {
      type: String,
      default: 'info',
    },
  },
};
</script>

<style scoped lang="scss">
.info_field {
  border-radius: 3px;

  &--info {
    background: linear-gradient(45deg, #8cbff252, #9dff9873);
  }
  &--warning {
    background: linear-gradient(45deg, #ffc10752, #ffe08273);
  }
  &--neutral {
    background: linear-gradient(45deg, #cfd8dc52, #eceff173);
  }
}
.theme--dark {
  .info_field {
    &--info {
      background: linear-gradient(45deg, rgb(178 251 255 / 32%), rgb(54 92 114 / 36%));
    }
    &--warning {
      background: linear-gradient(45deg, rgb(255 183 77 / 26%), rgb(120 76 32 / 40%));
    }
    &--neutral {
      background: linear-gradient(45deg, rgb(207 216 220 / 18%), rgb(69 90 100 / 40%));
    }
  }
}
</style>
